import { useCallback, useEffect, useRef } from 'react';

export function useNotifyScrollActivity<T extends HTMLElement = HTMLDivElement>(delay = 300) {
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(
        () => () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        },
        []
    );

    return useCallback(
        (element: T | null) => {
            if (!element) return;
            if (!element.hasAttribute('data-scrolling')) {
                element.setAttribute('data-scrolling', '');
            }
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                element.removeAttribute('data-scrolling');
            }, delay);
        },
        [delay]
    );
}
